import { render, staticRenderFns } from "./AccFoodPage.vue?vue&type=template&id=64bcf2a6&scoped=true&"
import script from "./AccFoodPage.vue?vue&type=script&lang=js&"
export * from "./AccFoodPage.vue?vue&type=script&lang=js&"
import style0 from "./AccFoodPage.vue?vue&type=style&index=0&id=64bcf2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bcf2a6",
  null
  
)

export default component.exports